import { TransferConstructionSiteEnum } from "src/app/enum/transfer-construction-site-enum";
import { RentalPeriodModel } from './rental-period.model';
import { CostCenterModel } from "../archive/cost-center.model";

export class TransferConstructionSiteModel {
  transferConstructionSiteId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  dateTransferConstructionSite: Date = new Date();
  // Centro de costos origen
  originCostCenterId: number = 0;
  originCostCenter: CostCenterModel | null = null;
  originDateInvoice: Date = new Date();
  originSwDontChargeInvoiceDay: boolean = false;
  originTransportValue: number = 0;
  originTransporterId: number = 0;
  originVehicleId: number = 0;
  // Centro de costos destino
  destinyCostCenterId: number = 0;
  destinyCostCenter: CostCenterModel | null = null;
  destinyDateInvoice: Date = new Date();
  destinyTransportValue: number = 0;
  destinyTransporterId: number = 0;
  destinyVehicleId: number = 0;
  observation: string | null = null;
  transferConstructionSiteStateId: number = TransferConstructionSiteEnum.abierta;
  remissionId: number = 0;
  devolutionId: number = 0;
  rentalPeriodId: number = 0;
  rentalPeriod: RentalPeriodModel = new RentalPeriodModel();
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}